import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js";
import api from "../../../api";
import PlantillaFormSections from "./PlantillaFormSections.js";

class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            descripcion: '',
            asunto: '',
            cuerpo: ''
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetForm() {
        this.setState({
            descripcion: '',
            asunto: '',
            cuerpo: ''
        });
    }

    setSelects(data) {
        this.setState(() => ({
            descripcion: data.descripcion,
            asunto: data.asunto,
            cuerpo: data.cuerpo
        }));
    }

    createMarkup = () => {
        return {__html: this.state.cuerpo};
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.email.plantillas.delete}
                postUrl={api.email.plantillas.delete}
                onSubmit={(e) => this.props.onSubmit(e)}
                id={this.props.id}
                successMessage={"La Plantilla de Mail ha sido eliminada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Plantilla de Mail"}
                buttonTitle={"Eliminar"}
                buttonIcon={"fa fa-trash fa-lg"}
                className={"ui-modal-dialog ui-modal-editor"}
                saveButton={true}
                buttonClass={"btn-danger"} 
                closeButton={true}
                danger={true}
                saveButtonLabel={"Eliminar"}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetForm()}
            >
                <div className="ui-form">
                    <div className="ui-alert ui-alert-danger">
                        <i className="ti ti-trash" aria-hidden="true"></i>
                        Se eliminará la plantilla de mail seleccionada.
                    </div>
                    <PlantillaFormSections
                        disabled={true}
                        descripcion={this.state.descripcion}
                        asunto={this.state.asunto}
                        cuerpo={this.state.cuerpo}
                    />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/Config/Plantillas/Delete.js